import { PropsWithChildren } from "react";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      ["swiper-slide"]: any;
    }
  }
}
export default function Slide({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return <swiper-slide class={className}>{children}</swiper-slide>;
}
